export enum ManufacturerType {
  SANDOZ = 'sandoz',
  OTHER_MANUFACTURERS = 'other_manufacturers',
}
